/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_InfoInputs */

const en_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

const fr_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infos`)
};

const de_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

const it_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni`)
};

const ru_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация`)
};

const es_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información`)
};

const zh_cn2_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信息`)
};

const ja_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`情報`)
};

const hi_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जानकारी`)
};

const pt_pt2_options_quicktools_info = /** @type {(inputs: Options_Quicktools_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações`)
};

/**
* | output |
* | --- |
* | "Info" |
*
* @param {Options_Quicktools_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_info = /** @type {((inputs?: Options_Quicktools_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_info(inputs)
	if (locale === "de") return de_options_quicktools_info(inputs)
	if (locale === "it") return it_options_quicktools_info(inputs)
	if (locale === "ru") return ru_options_quicktools_info(inputs)
	if (locale === "es") return es_options_quicktools_info(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_info(inputs)
	if (locale === "ja") return ja_options_quicktools_info(inputs)
	if (locale === "hi") return hi_options_quicktools_info(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_info(inputs)
	return en_options_quicktools_info(inputs)
});